import { ClockCounterClockwise } from "@phosphor-icons/react";
import { STATUSES } from "../../lib/api";

export const OrderTimeline = ({ order }) => (
  <div className="rounded-md border border-slate-200 bg-white p-5" data-testid="status-timeline">
    <h2 className="flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
      <ClockCounterClockwise size={18} weight="duotone" /> Timeline
    </h2>
    <ol className="mt-4 space-y-4 border-l border-slate-200 pl-4">
      {[...order.status_history].reverse().map((h) => (
        <li key={`${h.status}-${h.changed_at}`} className="relative">
          <span className="absolute -left-[21.5px] top-1 h-2.5 w-2.5 rounded-full border-2 border-white bg-slate-900" />
          <p className="text-sm font-semibold text-slate-900">
            {STATUSES.find((s) => s.value === h.status)?.label || h.status}
          </p>
          <p className="text-xs text-slate-500">{h.note}</p>
          <p className="mt-0.5 text-xs text-slate-400">
            {h.changed_by} · {new Date(h.changed_at).toLocaleString()}
          </p>
        </li>
      ))}
    </ol>
    <div className="mt-5 border-t border-slate-200 pt-4" data-testid="audit-trail">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Audit Trail</p>
      <p className="mt-2 text-xs text-slate-600" data-testid="audit-created">
        Created by <span className="font-semibold">{order.created_by}</span> · {new Date(order.created_at).toLocaleString()}
      </p>
      {(order.edit_history || []).map((e, i) => (
        <p key={`${e.edited_at}-${i}`} className="mt-1.5 text-xs text-slate-600" data-testid={`audit-edit-${i}`}>
          Edited by <span className="font-semibold">{e.edited_by}</span> · {new Date(e.edited_at).toLocaleString()}
          <span className="text-slate-400"> (changed: {e.changes.join(", ")})</span>
        </p>
      ))}
      {order.updated_by && (
        <p className="mt-1.5 text-xs font-medium text-amber-700" data-testid="audit-last-updated">
          Last updated by {order.updated_by} · {new Date(order.updated_at).toLocaleString()}
        </p>
      )}
    </div>
  </div>
);
